import {
  fetchIterableSubscriptionsRequest,
  updateIterableSubscriptions,
} from '@/requests';
import { IterableChannelUpdate, IterableSubscriptionGroup } from '@/types';

import { bffApi } from '../bff-api';

type FetchIterableSubscriptionsResponse = Omit<
  IterableSubscriptionGroup,
  'isChecked'
>[];

export const iterableApi = bffApi.injectEndpoints({
  endpoints: builder => ({
    fetchIterableSubscriptions: builder.query<
      FetchIterableSubscriptionsResponse,
      { token?: string }
    >({
      query: fetchIterableSubscriptionsRequest,
    }),
    updateIterableSubscriptions: builder.mutation<
      void,
      { channels: IterableChannelUpdate[]; token?: string }
    >({
      query: updateIterableSubscriptions,
    }),
  }),
});

export const {
  useFetchIterableSubscriptionsQuery,
  useUpdateIterableSubscriptionsMutation,
} = iterableApi;
